import { cn } from "cn";
import type * as React from "react";

/**
 * Полноэкранная обёртка с центрированием содержимого — общий каркас для
 * экранов вроде проверки сессии, недоступности демона или формы входа.
 * Компонент не знает, что за контент внутри: он приходит детьми.
 */
function CenterScreen({ className, ...props }: React.ComponentProps<"main">) {
  return (
    <main
      data-slot="center-screen"
      className={cn(
        "flex min-h-dvh items-center justify-center bg-background text-foreground p-8",
        className,
      )}
      {...props}
    />
  );
}

export { CenterScreen };
